<template>
  <svg viewBox="0 0 92 128" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="88.2922"
      y="96.4243"
      width="10.974"
      height="10.974"
      rx="2.9264"
      transform="rotate(180 88.2922 96.4243)"
      fill="#FFEAC4"
    />
    <rect
      x="69.6321"
      y="22.974"
      width="10.974"
      height="10.974"
      rx="2.9264"
      transform="rotate(180 69.6321 22.974)"
      fill="#2C0C00"
    />
    <rect
      x="88.2922"
      y="78.1342"
      width="10.974"
      height="10.974"
      rx="2.9264"
      transform="rotate(180 88.2922 78.1342)"
      fill="#FFEAC4"
    />
    <rect
      x="52.6266"
      y="97.3386"
      width="12.803"
      height="12.803"
      rx="2.1948"
      transform="rotate(180 52.6266 97.3386)"
      fill="#FFEAC4"
    />
    <rect
      x="52.6266"
      y="42.4686"
      width="12.803"
      height="12.803"
      rx="2.1948"
      transform="rotate(180 52.6266 42.4686)"
      fill="#FFB838"
    />
    <rect
      x="70.9166"
      y="60.7586"
      width="12.803"
      height="12.803"
      rx="2.1948"
      transform="rotate(180 70.9166 60.7586)"
      fill="#FFAD1A"
    />
    <rect
      x="53.5411"
      y="79.9631"
      width="14.632"
      height="14.632"
      rx="1.4632"
      transform="rotate(180 53.5411 79.9631)"
      fill="#FFEAC4"
    />
    <rect
      x="70.9166"
      y="97.3386"
      width="12.803"
      height="12.803"
      rx="2.1948"
      transform="rotate(180 70.9166 97.3386)"
      fill="#FFEAC4"
    />
    <rect
      x="52.6266"
      y="115.629"
      width="12.803"
      height="12.803"
      rx="2.1948"
      transform="rotate(180 52.6266 115.629)"
      fill="#FFEAC4"
    />
    <rect
      x="53.5411"
      y="61.6732"
      width="14.632"
      height="14.632"
      rx="1.4632"
      transform="rotate(180 53.5411 61.6732)"
      fill="#FFAD1A"
    />
    <rect
      x="70.0022"
      y="41.5541"
      width="10.974"
      height="10.974"
      rx="2.9264"
      transform="rotate(180 70.0022 41.5541)"
      fill="#2C0C00"
    />
    <rect
      x="70.0022"
      y="114.714"
      width="10.974"
      height="10.974"
      rx="2.9264"
      transform="rotate(180 70.0022 114.714)"
      fill="#FFEAC4"
    />
    <rect
      x="70.9166"
      y="79.0486"
      width="12.803"
      height="12.803"
      rx="2.1948"
      transform="rotate(180 70.9166 79.0486)"
      fill="#FFEAC4"
    />
    <rect
      x="33.4221"
      y="114.714"
      width="10.974"
      height="10.974"
      rx="2.9264"
      transform="rotate(180 33.4221 114.714)"
      fill="#FFEAC4"
    />
    <rect
      x="34.3365"
      y="97.3386"
      width="12.803"
      height="12.803"
      rx="2.1948"
      transform="rotate(180 34.3365 97.3386)"
      fill="#FFEAC4"
    />
    <rect
      x="34.3365"
      y="79.0486"
      width="12.803"
      height="12.803"
      rx="2.1948"
      transform="rotate(180 34.3365 79.0486)"
      fill="#FFEAC4"
    />
    <rect
      x="34.3365"
      y="61.1785"
      width="12.803"
      height="12.803"
      rx="2.1948"
      transform="rotate(180 34.3365 61.1785)"
      fill="#FFAD1A"
    />
    <rect
      x="33.4221"
      y="41.5541"
      width="10.974"
      height="10.974"
      rx="2.9264"
      transform="rotate(180 33.4221 41.5541)"
      fill="#2C0C00"
    />
    <rect
      x="33.4221"
      y="22.974"
      width="10.974"
      height="10.974"
      rx="2.9264"
      transform="rotate(180 33.4221 22.974)"
      fill="#2C0C00"
    />
    <rect
      x="87.3777"
      y="113.8"
      width="9.145"
      height="9.145"
      rx="3.658"
      transform="rotate(180 87.3777 113.8)"
      fill="#FFEAC4"
    />
    <rect
      x="87.3777"
      y="40.6396"
      width="9.145"
      height="9.145"
      rx="3.658"
      transform="rotate(180 87.3777 40.6396)"
      fill="#FFB838"
    />
    <rect
      x="14.2175"
      y="113.8"
      width="9.145"
      height="9.145"
      rx="3.658"
      transform="rotate(180 14.2175 113.8)"
      fill="#FFEAC4"
    />
    <rect
      x="15.1321"
      y="96.4243"
      width="10.974"
      height="10.974"
      rx="2.9264"
      transform="rotate(180 15.1321 96.4243)"
      fill="#FFEAC4"
    />
    <rect
      x="15.1321"
      y="78.1342"
      width="10.974"
      height="10.974"
      rx="2.9264"
      transform="rotate(180 15.1321 78.1342)"
      fill="#FFEAC4"
    />
    <rect
      x="15.1321"
      y="59.8441"
      width="10.974"
      height="10.974"
      rx="2.9264"
      transform="rotate(180 15.1321 59.8441)"
      fill="#FFAD1A"
    />
    <rect
      x="14.2175"
      y="40.6396"
      width="9.145"
      height="9.145"
      rx="3.658"
      transform="rotate(180 14.2175 40.6396)"
      fill="#FFB838"
    />
    <rect
      x="88.2922"
      y="59.8441"
      width="10.974"
      height="10.974"
      rx="2.9264"
      transform="rotate(180 88.2922 59.8441)"
      fill="#FFAD1A"
    />
  </svg>
</template>